module.exports = __webpack_public_path__ + "img/ii-1@2x.ef5be04f.png";